import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { Tooltip } from 'react-tippy'
import InfoButton from '../../../../components/ui/buttons/InfoButton'
import numberConverter from '../../../../utils/tuition/numberForCurrency'
import Insight from '../../../../components/renderPropComponents/Insight'

export default class VerticalBarChart extends Component {
  static propTypes = {
    capitalize: PropTypes.func.isRequired,
    data: PropTypes.array,
    disabled: PropTypes.bool,
    isMobile: PropTypes.bool,
    keyForValue: PropTypes.string,
    onBarClick: PropTypes.func,
    selectedValue: PropTypes.string,
    showInsight: PropTypes.bool,
    title: PropTypes.string,
    infoContent: PropTypes.string,
  }

  render() {
    const {
      data,
      disabled,
      isMobile,
      keyForValue,
      onBarClick,
      selectedValue,
      title,
      infoContent,
      showInsight,
      capitalize,
      className,
    } = this.props

    return (
      <div className={isMobile ? 'col-6' : 'col-3'} style={{ padding: 15, paddingTop: 0 }}>
        <div style={{ paddingTop: 10 }}>
          <Insight content="CLICK a major to get started!" willShow={showInsight}>
            <h5 style={{ textAlign: 'center' }}>
              {title}
              {infoContent && (
                <span className="pull-right" style={{ marginTop: -3 }}>
                  <InfoButton
                    content={infoContent}
                    iconClass="fal fa-info-circle"
                    styles={{ paddingRight: 10 }}
                  />
                </span>
              )}
            </h5>
            <div
              style={{
                marginTop: 10,
                overflow: 'auto',
                maxHeight: 400,
                borderRadius: 3,
              }}
            >
              {data && !!data.length ? (
                data.map(rowData => (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                  <div
                    key={`${JSON.stringify(rowData)}`}
                    onClick={disabled ? null : () => onBarClick(rowData)}
                    className={`bar-filter ${className}`}
                    style={{
                      cursor: disabled ? 'default' : 'pointer',
                      opacity: disabled ? 0.5 : 1,
                    }}
                  >
                    <Tooltip
                      title={
                        !!get(rowData, 'rawMetric', 0)
                          ? `Avg. Salary: $${numberConverter(get(rowData, 'rawMetric', 0))}`
                          : 'Not enough data'
                      }
                      position="top"
                      arrow
                      sticky={true}
                    >
                      <div>{capitalize(rowData.key)}</div>
                      <div className="vertical-bar-container">
                        <div className="scale-bars-icon">
                          <i className="fas fa-hashtag" />
                        </div>
                        <div className="scale-bars scale-bars-right">
                          <div
                            className="scale-bars-with-icon"
                            style={{
                              cursor: disabled ? 'default' : 'pointer',
                              width: `${rowData[keyForValue]}%`,
                              backgroundColor:
                                selectedValue && selectedValue !== rowData.key
                                  ? 'transparent'
                                  : '#87b9e9',
                              border: '1px solid #87b9e9',
                            }}
                          />
                        </div>
                      </div>
                      <div className="vertical-bar-container" style={{ marginTop: 7 }}>
                        <div className="scale-bars-icon">
                          <i className="far fa-usd-circle" />
                        </div>
                        <div className="scale-bars scale-bars-right">
                          <div
                            className="scale-bars-with-icon"
                            style={{
                              cursor: disabled ? 'default' : 'pointer',
                              width: `${rowData.metric}%`,
                              backgroundColor:
                                selectedValue && selectedValue !== rowData.key
                                  ? 'transparent'
                                  : '#87d0c0',
                              border: '1px solid #87d0c0',
                            }}
                          />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                ))
              ) : (
                <div className="text-center" style={{ paddingTop: '49%' }}>
                  <i className="fal fa-times-circle" style={{ fontSize: 20 }} /> <br />
                  <div style={{ fontSize: 13 }}>Small Sample Size</div>
                </div>
              )}
            </div>
          </Insight>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Outcomes/components/VerticalBarChart.js